module.exports = __webpack_public_path__ + "img/sensor-on.4f3e259f.svg";